import type { DeliveryPopupChromeLayout } from './deliveryPopupLayout';
import { DELIVERY_POPUP_LAYOUT } from './deliveryPopupLayout';
import './DeliveryPopupReward.css';

type DeliveryPopupRewardProps = {
  passReward: number;
  layout?: DeliveryPopupChromeLayout['rewardAmount'];
};

/** Figma reward_amount_text — Matias 40px white. */
export function DeliveryPopupReward({
  passReward,
  layout = DELIVERY_POPUP_LAYOUT.rewardAmount,
}: DeliveryPopupRewardProps) {
  return (
    <svg
      className="delivery-popup-reward"
      style={{
        left: layout.left,
        top: layout.top,
        width: 60,
        height: layout.height,
      }}
      viewBox="0 0 60 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <text
        className="delivery-popup-reward__text"
        textAnchor="start"
        xmlSpace="preserve"
      >
        <tspan x={0} y={36}>
          +{passReward}
        </tspan>
      </text>
    </svg>
  );
}
